import React, { Component, Fragment } from 'react'
import { slide as Menu } from 'react-burger-menu';
import './styles.css';
import A5Img from '../../assets/svg/a5-logo.svg';

class SideMenu extends Component {
  render() {
    const { children, isOpen, stateModal  } = this.props;
    return (
      <Fragment>
          <Menu isOpen={isOpen}>
              <div className="sidemenu">
                  <img src={A5Img} alt="" className="sidemenu-logo" />
                  <div className="sidemenu-container" >
                      {children}
                  </div>
              </div>
          </Menu>
      </Fragment>
    )
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.js